import {userSlice} from '../slices';
import store from '../../store';
import {axios} from '../../libs';
import logger from '../../utils/logger';
const {nError} = window;

const Actions = userSlice.actions;

const {dispatch, getState} = store;

const set = (data) => {
  dispatch(Actions.set(data));
};

const get = () => {
  return (state) => state.user;
};

const getSession = async () => {
  try {
    const {user} = await axios.get('/user', {}, { silent: true });
    dispatch(Actions.set(user));
    return user;
  } catch (error) {
    return false;
  }
};

const forceRefresh = async () => {
  try {
    // Clear current state first
    dispatch(Actions.set(null));
    // Then fetch fresh data
    const {user} = await axios.get('/user');
    dispatch(Actions.set(user));
    return user;
  } catch (error) {
    logger.error('Force refresh failed:', error);
    return false;
  }
};

const isAdmin = () => {
  const _user = getState().user;
  return _user.role === 'admin';
};

export const User = {
  set,
  get,
  getSession,
  isAdmin,
  clear: () => dispatch(Actions.set(null)),
  forceRefresh,
};
